import { translate } from "../utils/translations/translate";
import DashboardCustomizeSharpIcon from "@mui/icons-material/DashboardCustomizeSharp";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import ApprovalRoundedIcon from "@mui/icons-material/ApprovalRounded";
import PunchClockRoundedIcon from "@mui/icons-material/PunchClockRounded";
import SettingsIcon from "@mui/icons-material/Settings";
import SummarizeIcon from "@mui/icons-material/Summarize";
export const SITE_LINKS_SCHEMA = {
  LOGIN: "/auth/login",
  FORGOT_PASS: "/auth/forgotPass",
  RESET_PASS: "/auth/resetPass",
  USER_MANAGEMENT: "/u/management",
  CREATE_RESOURCE: "/u/create",
  UPDATE_RESOURCE: "/u/:resourceId",
  PROJECT_ENGAGEMENTS: "/p/engagements",
  PROJECT_CREATION: "/p/create",
  PROJECT_UPDATE: "/p/update/:projectId",
  TIME_SHEET_MANAGEMENT: "/t/management",
  TIME_SHEET_APPROVAL: "/t/approve",
  TIME_SHEET_APPROVAL_DETAILS: "/t/approve/:timesheetId",
  TIME_SHEET_CORRECTION_DETAILS: "/t/manage/:timesheetId",
  SETTINGS: "/settings",
  REPORTS: "/reports",
  HOME: "/",
  PROFILE: "/u/profile",
  DASHBOARD: "/dashboard",
  ADMIN_DASHBOARD: "/adminDashboard",
  NOTIFICATIONS: "/notifications",
  FORBIDDEN: "/403",
  PAGE_NOT_FOUND: "*",
};
export const NAV_LINKS = [
  {
    path: SITE_LINKS_SCHEMA.ADMIN_DASHBOARD,
    title: translate("nav.adminDashboard"),
    icon: DashboardIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.DASHBOARD,
    title: translate("nav.dashboard"),
    icon: DashboardCustomizeSharpIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.PROJECT_ENGAGEMENTS,
    title: translate("nav.projectEngagements"),
    icon: AccountTreeRoundedIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.USER_MANAGEMENT,
    title: translate("nav.userManagement"),
    icon: ManageAccountsRoundedIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.TIME_SHEET_APPROVAL,
    title: translate("nav.timeSheetApproval"),
    icon: ApprovalRoundedIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.TIME_SHEET_MANAGEMENT,
    title: translate("nav.timesheet"),
    icon: PunchClockRoundedIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.SETTINGS,
    title: translate("nav.settings"),
    icon: SettingsIcon,
  },
  {
    path: SITE_LINKS_SCHEMA.REPORTS,
    title: translate("nav.reports"),
    icon: SummarizeIcon,
  },
];
export const ROLE_FLAGS = [
  "IsAccountCreator",
  "IsProjectCreator",
  "IsProjectTaskCreator",
  "IsApprover",
];
export const APP_LINKS = [
  {
    path: SITE_LINKS_SCHEMA.HOME,
    title: "Home",
    requiresAuth: false,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.DASHBOARD,
    title: "Dashboard",
    requiresAuth: true,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.ADMIN_DASHBOARD,
    title: "Admin Dashboard",
    requiresAuth: true,
    IsProjectCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.NOTIFICATIONS,
    title: "Notifications",
    requiresAuth: true,
    isCommonRoute: true,
    hideSideBar: true,
  },
  {
    path: SITE_LINKS_SCHEMA.LOGIN,
    title: "Login",
    requiresAuth: false,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.FORGOT_PASS,
    title: "Forgot Password",
    requiresAuth: false,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.RESET_PASS,
    title: "Reset Password",
    requiresAuth: false,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.USER_MANAGEMENT,
    title: "User Management",
    requiresAuth: true,
    IsAccountCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.CREATE_RESOURCE,
    title: "Create Resource",
    requiresAuth: true,
    IsAccountCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.UPDATE_RESOURCE,
    title: "Update Resource",
    requiresAuth: true,
    IsAccountCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.PROFILE,
    title: "My Profile",
    requiresAuth: true,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.PROJECT_ENGAGEMENTS,
    title: "Project Engagement",
    requiresAuth: true,
    IsProjectCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.PROJECT_UPDATE,
    title: "Update Project",
    requiresAuth: true,
    IsProjectCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.PROJECT_CREATION,
    title: "New Project",
    requiresAuth: true,
    IsProjectCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.TIME_SHEET_MANAGEMENT,
    title: "Time Sheet",
    requiresAuth: true,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.TIME_SHEET_APPROVAL,
    title: "Time Sheet Approval",
    requiresAuth: true,
    IsApprover: true,
  },
  {
    path: SITE_LINKS_SCHEMA.TIME_SHEET_APPROVAL_DETAILS,
    title: "Time Sheet Approval",
    requiresAuth: true,
    IsApprover: true,
  },
  {
    path: SITE_LINKS_SCHEMA.TIME_SHEET_CORRECTION_DETAILS,
    title: "Time Sheet Correction",
    requiresAuth: true,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.FORBIDDEN,
    title: "403 Forbidden",
    requiresAuth: true,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.PAGE_NOT_FOUND,
    title: "Page Not Found",
    requiresAuth: false,
    isCommonRoute: true,
  },
  {
    path: SITE_LINKS_SCHEMA.SETTINGS,
    title: "Settings",
    requiresAuth: true,
    IsProjectTaskCreator: true,
  },
  {
    path: SITE_LINKS_SCHEMA.REPORTS,
    title: "Reports",
    requiresAuth: true,
    IsProjectTaskCreator: true,
  },
];
